import * as z from "zod";

export const getAvgTimeToResolutionByCarrier = {
  name: "getAvgTimeToResolutionByCarrier" as const,
  input: z.object({
    startDate: z.coerce.date(),
    endDate: z.coerce.date(),
    grain: z.enum(["daily", "weekly", "monthly"]).default("monthly"),
    canonicalLocationExternalId: z.string().optional(),
    timezone: z.string().optional(),
  }),
  output: z.object({
    data: z.array(
      z.object({ date: z.string(), carrier: z.string(), avgDays: z.number() }),
    ),
  }),
};
